
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { User } from "@/graph/servicecloud/users";
import graph from "@/graph";
import SettingDebug from "./modules/settingDebug.vue";
import SettingCustomerSearch from "./modules/settingCustomerSearch.vue";
import SettingFallback from "./modules/settingFallback.vue";
import { v4 as uuidv4 } from "uuid";

@Component({
	components: {
		SettingDebug,
		SettingCustomerSearch,
		SettingFallback,
	},
})
export default class UserEdit extends Vue
{
	@Prop(String) userId: string | undefined;
	@Prop({ default: true }) readonly visible!: boolean;

	currentKey = "";

	loading = true;
	userData: User | null = null;
	permissions: string[] = [];
	showAllPermissions = false;
	saveButtonLoading = false;
	saveButtonText = "Save";

	settingToAdd = "";
	settingsList = [
		"customerSearch",
		"debug",
		"salesforce",
		"deliveryOptions",
	];

	@Watch("userId")
	onUserkeyChange(current: string, old: string)
	{
		console.log("UserEdit::onUserkeyChange", "current", current, "old", old);

    if (current.length === 0) {
      return;
    }
			this.loadData();
	}

	addSetting()
	{
		if(this.settingToAdd.length <= 0)
		{
			return;
		}

		if(this.isSettingSet(this.settingToAdd))
		{
			return;
		}

		if(this.userData && this.userData.settings)
		{
			this.userData.settings.push({
				key: this.settingToAdd,
				value: "{}",
				type: "JSON",
			});
		}
	}

	isSettingSet(name: string): boolean
	{
		if(this.userData && this.userData.settings)
		{
			for(const setting of this.userData.settings)
			{
				if(setting.key === name)
				{
					return true;
				}
			}
		}

		return false;
	}

	querySearch(queryString: string, cb: any)
	{
		console.log("UserEdit querySearch", "queryString", queryString);

		var settingsList = this.settingsList;
		var results = queryString ? settingsList.filter(this.createFilter(queryString)) : settingsList;
		// call callback function to return suggestions
		console.log("UserEdit querySearch", "filter results", results);

		const out: { value: string }[] = [];

		for(const r of results)
		{
			out.push({
				value: r,
			});
		}

		cb(out);
	}

	createFilter(queryString: string)
	{
		return (elem: string) => {
			const out = elem.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
			console.log("filter", "elem", elem.toLowerCase(), "querystring", queryString.toLowerCase(), "in", out);
			return out;
		};
	}

	generateUUID(name: string)
	{
		console.log("UserEdit generateUUID", "name", name);

		if(name === "key")
		{
			if(this.userData)
			{
				this.userData.key = uuidv4();
			}
		}
		else if(name === "secret")
		{
			if(this.userData)
			{
				this.userData.secret = uuidv4();
			}
		}
	}

	settingUpdate(key: string, value: string)
	{
		console.log("UserEdit settingUpdate", "key", key, "value", value);

		if(this.userData)
		{
			if(this.userData.settings)
			{
				for(const i in this.userData.settings)
				{
					if(this.userData.settings[i].key === key)
					{
						this.userData.settings[i].value = value;
					}
				}
			}
		}
	}

	permissionUpdate(active: boolean, element: {srcElement: HTMLInputElement})
	{
		console.log("UserEdit permissionUpdate", "element", element, "active", active);

		if(element.srcElement.name)
		{
			if(this.userData && this.userData.permission)
			{
				for(const i in this.userData.permission)
				{
					if(this.userData.permission[i].key === element.srcElement.name)
					{
						if(active)
						{
							this.userData.permission[i].value = "true";
						}
						else
						{
							this.userData.permission[i].value = "false";
							// this.$delete(this.userData.permission, i);
						}

						return;
					}
				}

				this.userData.permission.push({
					key: element.srcElement.name,
					value: active ? "true" : "false",
					type: "BOOLEAN",
				});
			}
		}
	}

	isPermissionSet(permission: string): boolean
	{
		if(this.userData && this.userData.permission)
		{
			for(const perm of this.userData.permission)
			{
				if(perm.key === permission)
				{
					if(perm.value === "true")
					{
						return true;
					}

					return false;
				}
			}
		}

		return false;
	}

	async save()
	{
		console.log("UserEdit save", "userData", this.userData);

		this.saveButtonLoading = true;
		this.saveButtonText = "Saving ...";

		if(this.userData)
		{
			const result = await graph.servicecloud.users.updateUser(
				this.userData.id,
        this.userData.name,
				this.userData.key,
				this.userData.secret,
				this.userData.permission ?? [],
				this.userData.settings ?? [],
				this.userData.salesOrganisation
			);
      this.$emit("user-updated", true);
			console.log("UserEdit save", "saveresult", result);
		}

		this.saveButtonLoading = false;
		this.saveButtonText = "Save";
	}

	async updated()
	{
		console.log("UserEdit updated", "userkey", this.userId, "visible", this.visible, "currentkey", this.currentKey);

		// if(this.visible == true && this.userkey !== "" && this.userkey !== this.currentKey)
		// {
		// 	await this.loadData();
		// }
	}

	activated()
	{
		console.log("UserEdit activated", this.userId);
	}

	async loadData()
	{
		console.log("UserEdit::loadData", "currentKey:", this.userId);

		this.currentKey = this.userId ?? "";
		this.loading = true;
		const result = await graph.servicecloud.users.get(this.userId ?? "");
		this.permissions = await graph.servicecloud.users.getAccessPermissions();

		if(result.length > 0)
		{
			const user = result.pop();

			if(user)
			{
				this.userData = user;
			}
		}

		this.loading = false;
	}

	beforeUpdate()
	{
		console.log("UserEdit::beforeUpdate", "userkey", this.userId, "visible", this.visible, "currentkey", this.currentKey);
	}

	deactivated()
	{
		console.log("UserEdit::deactivated", "userkey", this.userId, "visible", this.visible, "currentkey", this.currentKey);
	}

	async mounted()
	{
		console.log("UserEdit mounted", "userkey", this.userId, "visible", this.visible, "currentkey", this.currentKey);

		if(this.visible == true && this.userId !== "" && this.userId !== this.currentKey)
		{
			await this.loadData();
		}
	}

}
